export default {
  init() {
    addBackButtonFunctionality();
    addClassToSinglePrice();
    // showProductSalePercentage();
    backToTop();

    dontShowCategoryFooterContentWhenFiltering();

    //saveFilterValues();

    //resetFilters();
    $(document).wsFilters();
    //getFilterValues();

    // $(document).on('click', '.products .product', function ( event ) {
    //   event.preventDefault();
    //   //event.stopPropagation();
    //   //event.stopImmediatePropagation();
    //   //alert('test123');
    //   var data = {
    //     action: 'ws_product_detail',
    //   };
    //   /* global woof_ajaxurl */
    //   jQuery.post(woof_ajaxurl, data, function (content) {
    //     content = jQuery.parseJSON(content);
    //     console.log(content);
    //
    //     let contentContainer = $('#main');
    //
    //     $('body').addClass('single-product');
    //     contentContainer.html(content.html);
    //
    //     $('head').html(content.head);
    //     $('body').append(content.footer);
    //     $(document).trigger('load');
    //
    //
    //     // TODO: Set the url to the real detail page URL
    //   });
    // });


  },
  finalize() {

  },
};

/*
export var resetFilters = () => {
  $('.woof_reset_search_form').click(function() {
    if ($('.woof_products_top_panel ul li').length == 0) {
      $('.woof_submit_search_form_container').hide();
    } else {
      $('.woof_submit_search_form_container').show();
    }
  });
}

export var saveFilterValues = () => {
  $('.woof_mselect').change(function(){
    localStorage.setItem($(this).attr('name'),$(this).val());
  });
  $('.woof_list').change(function(){
    localStorage.setItem($(this).attr('name'),$(this).val());
  });
}

export var getFilterValues = () => {
  $('.woof_mselect').each(function(){
    $(this).val(localStorage.getItem($(this).attr('name')));
  });
  $('.woof_list').each(function(){
    $(this).val(localStorage.getItem($(this).attr('name')));
  });

}
*/

export var backToTop = () => {
  $(window).resize(function () {
    if ($(window).width() > 1024) {
      $('.mobile-filters').fadeOut();
      $('.backtotop-container').fadeOut();
    } else {
      if ($(this).scrollTop() > 100) {
        $('.mobile-filters').fadeIn();
        $('.backtotop-container').fadeIn();
      }
    }
  });

  $(window).scroll(function () {

    if ($(this).scrollTop() > 100) {
      $('.backtotop-container').fadeIn();
    } else {
      $('.backtotop-container').fadeOut();
    }
  });

  $('.wolky-backtotop').click(function () {
    $('html, body').animate({scrollTop: 0}, 1000);
  });
}

export var addClassToSinglePrice = () => {
  $('.price:has(> .woocommerce-Price-amount)').addClass('single_price');
}

export var addBackButtonFunctionality = () => {
  $('#back-button').on('click', function (e) {
    e.preventDefault();
    window.history.back();
  });
}

export var dontShowCategoryFooterContentWhenFiltering = () => {
  jQuery('body').on('click', '.woocommerce-pagination a.page-numbers', function () {
    $('.category-footer-content').hide();
  });
}
